import { render } from "./Fire.vue?vue&type=template&id=41515e00"
const script = {}

import exportComponent from "/home/runner/work/demonology/demonology/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__